var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload18Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2373 9.37494V12.5249C13.2373 12.9187 12.9186 13.2374 12.5248 13.2374H5.4748C5.08105 13.2374 4.7623 12.9187 4.7623 12.5249V9.37494H3.4873V12.5249C3.4873 13.6199 4.3798 14.5124 5.4748 14.5124H12.5248C13.6198 14.5124 14.5123 13.6199 14.5123 12.5249V9.37494H13.2373Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9998 10.7924C9.29605 10.7924 9.58105 10.6687 9.7873 10.4549L12.0561 8.07369L11.1336 7.19244L9.63731 8.76369V3.50244H8.3623V8.76369L6.86605 7.19244L5.94355 8.07369L8.2123 10.4549C8.4148 10.6687 8.70355 10.7924 8.9998 10.7924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload18Line);
export default __webpack_public_path__ + "static/media/icon_download_18_line.3981797c74f53412b665884a764c3b4d.svg";
export { ForwardRef as ReactComponent };